import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PageAction } from '../../../components/page-actions/page-actions.component';
import { Models } from '@ibexfusion/models';
import { CompositionAppService } from '@services/compositions/composition-app.service';
import { CompositionAppWidgetService } from '@services/compositions/composition-app-widget.service';
import { DataTableComponent } from '../../../components/data-table/data-table.component';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { CompositionService } from '@services/compositions/composition.service';
import { ImportService } from '@services/imports/import.service';
import { MenuItemService } from '@services/menu-items/menu-item.service';

@Component({
    selector: 'composition-app-detail',
    templateUrl: './composition-app-detail.component.html',
    styleUrls: ['./composition-app-detail.component.scss'],
    providers: [CompositionService, ImportService, CompositionAppWidgetService, CompositionAppService, MenuItemService],
    standalone: false
})
export class CompositionAppDetailComponent implements OnInit {

  public pageActions: PageAction[];

  public params: any;

  public pageTitle = 'Overview App: ';

  public compositionApp: Models.CompositionApp;

  public importerByMenuItem: Map<string, Models.Import> = new Map();

  public isLoading = false;

  @ViewChild('dataTable') dataTable: DataTableComponent;

  constructor(
    public compositionAppService: CompositionAppService, private importService: ImportService, private activatedRoute: ActivatedRoute, private snackbar: SnackbarService,
    private router: Router, private menuItemService: MenuItemService
  ) {
  }

  async ngOnInit() {
    this.isLoading = true;
    this.createPageActions();
    this.params = { compositionAppId: this.activatedRoute.snapshot.params['appId'] };
    this.compositionApp = await this.compositionAppService.get(this.activatedRoute.snapshot.params['appId']);
    for (let i = 0; i < this.compositionApp.translations.length; i++) {
      if (!this.compositionApp.translations[i].items) {
        this.compositionApp.translations[i].items = this.compositionApp.translations[i].menuItemIds;
      }
    }
    this.pageTitle += this.compositionApp.name;
    if (this.compositionApp.translations && this.compositionApp.translations.length) {
      await this.createImporterMap(this.compositionApp.compositionId)
      this.isLoading = false;
    } else {
      this.isLoading = false;
    }
  }

  public async saveCompositionApp(event): Promise<any> {
    const index = this.compositionApp.translations.findIndex(item => item.language === event.language);
    if (index === -1) {
      this.snackbar.error('Failed, translation not found');
      return;
    }
    this.compositionApp.translations[index].menuItemIds = event.menuItemIds;
    try {
      await this.compositionAppService.update(this.activatedRoute.snapshot.params['appId'], this.compositionApp)
      this.snackbar.success('New order saved');
    } catch (err) {
      this.snackbar.error('Failed saving composition app');
    }
  }

  private async createImporterMap(compositionId): Promise<void> {
    const menuItems = [];
    this.compositionApp.translations.map(app => {
      app.items.map(item => {
        if (typeof item === 'string') {
          if (!!item && menuItems.indexOf(item) === -1) {
            menuItems.push(item);
          }
        } else {
          menuItems.push(item);
        }
      })
    });
    const items = await this.menuItemService.find(0, 500, { _id: { $in: menuItems } });
    let query: any = { compositionId: this.activatedRoute.snapshot.params['id'] };
    if (items?.data?.length) {
      query = { _id: { $in: items.data.map(el => el.importId) } };
    }
    const imports = await this.importService.find(0, 500, query);
    menuItems.map(id => {
      const importer = imports.data.find(item => {
        if (item && item.assignableMenuItems && item.assignableMenuItems.length) {
          return item.assignableMenuItems[0].menuItemId === id.toString();
        } else {
          console.log('item not found: ', item, id);
        }
      })
      if (importer) {
        this.importerByMenuItem.set(id, importer);
      }
    });
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'account_balance', title: 'Overview Composition',
        callback: () => {
          this.router.navigate(['compositions', this.activatedRoute.snapshot.params['id']]);
        }
      }),
      new PageAction({
        icon: 'edit', title: 'Edit app',
        callback: () => {
          this.router.navigate(['compositions', this.activatedRoute.snapshot.params['id'], 'apps', this.activatedRoute.snapshot.params['appId'], 'edit']);
        }
      }),
      new PageAction({
        icon: 'create_new_folder', title: 'Create widget',
        callback: () => {
          this.router.navigate(['compositions', this.activatedRoute.snapshot.params['id'], 'apps', this.activatedRoute.snapshot.params['appId'], 'widgets', 'create']);
        }
      })
    ];
  }
}
